import * as React from "react";
import { type LucideIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { REVIEW_TONE_CLASSES, type ReviewTone } from "./utils";

type ReviewStatusBadgeProps = {
  label: string;
  icon: LucideIcon | null;
  tone: ReviewTone;
  className?: string;
};

export function ReviewStatusBadge({ label, icon: Icon, tone, className }: ReviewStatusBadgeProps) {
  return (
    <Badge variant="default" className={cn("gap-1 border", REVIEW_TONE_CLASSES[tone].badge, className)}>
      {Icon && <Icon className="size-3.5" />}
      {label}
    </Badge>
  );
}
